import { render, staticRenderFns } from "./ImportСonfigurations.vue?vue&type=template&id=70b79043&scoped=true"
import script from "./ImportСonfigurations.vue?vue&type=script&lang=js"
export * from "./ImportСonfigurations.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70b79043",
  null
  
)

export default component.exports